// import axios from '@/lib/axios';
import config from './config';

function getUserQuotas(params) {
  return Ajax.get(config.userQuotas, params);	
}

export {
  getUserQuotas
};



// WEBPACK FOOTER //
// ./src/api/basicInstance/list/actions.js